import PasswordInput, { PASSWORD_RULES, PasswordRule } from './PasswordInput';

export { PASSWORD_RULES };
export type { PasswordRule };
export default PasswordInput;
